import cs from 'classnames';
import { useRouter } from 'next/router';
import type { ComponentType } from 'react';
import React from 'react';
import { LINKS } from '@/Module/Core/Constant';
import { IconLearningActive, IconLearningUsual, IconSearchActive, IconSearchUsual, IconSubscriptionActive, IconSubscriptionUsual, IconWorkspaceActive, IconWorkspaceDeActive } from '@/Module/Icon';
import type { IIconProps } from '@/Module/Icon/Model';
enum SectionTypes {
  WORKSPACE,
  LEARNING,
  SEARCH,
  SUBSCRIPTION,
}
interface MenuItem {
  key: number;
  title: string;
  iconUsual: ComponentType<IIconProps>;
  iconActive: ComponentType<IIconProps>;
  href: string;
}
const LoggedInHeaderDesktop = () => {
  const router = useRouter();
  const MenuItem: MenuItem[] = [{
    key: SectionTypes.WORKSPACE,
    href: LINKS.WORKSPACE.MAIN,
    title: 'میزکار',
    iconActive: IconWorkspaceActive,
    iconUsual: IconWorkspaceDeActive
  }, {
    key: SectionTypes.LEARNING,
    href: LINKS.LEARNING,
    title: 'یادگیری',
    iconActive: IconLearningActive,
    iconUsual: IconLearningUsual
  }, {
    key: SectionTypes.SEARCH,
    href: LINKS.DISCOVER,
    title: 'جستجو',
    iconActive: IconSearchActive,
    iconUsual: IconSearchUsual
  }, {
    key: SectionTypes.SUBSCRIPTION,
    href: LINKS.SUBSCRIPTION.MAIN,
    title: 'اشتراک',
    iconActive: IconSubscriptionActive,
    iconUsual: IconSubscriptionUsual
  }];
  return <div className="flex items-center justify-start gap-5" data-sentry-component="LoggedInHeaderDesktop" data-sentry-source-file="LoggedInHeaderDesktop.tsx">
      {MenuItem.map(item => <button key={item.key} type="button" onClick={() => router.push(item.href)} className={cs('flex items-center text-base font-bold text-blueSix py-3 px-4 rounded-xl gap-2', `${`${router.pathname}/` === item.href ? 'bg-blueOne' : 'bg-none'}`)}>
          {`${router.pathname}/` === item.href ? <item.iconActive size="small" className="text-blueTwo" /> : <item.iconUsual size="small" />}
          {item.title}
        </button>)}
    </div>;
};
export default React.memo(LoggedInHeaderDesktop);